import { createFileRoute } from '@tanstack/react-router';

import PraetorSettings from '~/app/praetors/settings/praetor';

export const Route = createFileRoute('/_app/home/praetors/$praetorId/settings/')({
	beforeLoad: () => ({
		getTitle: 'Settings'
	}),
	component: PraetorSettings
});
